import { ERROR_API_NAME } from "../constants/variables";
import { checkinForSegments, decryptCheckinData } from "../dataLayer/CheckinData";
import { OriginAndDestination } from "../dataLayer/OriginAndDestination";
import { extractResource } from "../helper/extractResource";
import { deepCopy } from "../utils/jsonUtils";
import { errorHandingErrorMessage } from "./errrorHandling/errorHandling";

export async function checkinSuccessfulProcess(segmentList, passengerInfo) {
  try {
    const response = {
      status: true,
      code: 200,
      data: []
    };

    for (let segmentInd = 0; segmentInd < segmentList.length; segmentInd++) {
      const segInfo = segmentList[segmentInd]?.journeyDetails.segments;
      for (let segInd = 0; segInd < segInfo.length; segInd++) {
        const segDetails = segInfo[segInd];
        const tempSegmentArray = [];
        tempSegmentArray.push(segDetails?.segmentKey); // currently api accept only segment

        const apiObj = {
          segmentKeys: tempSegmentArray,
          notification: {
            notifySMS: true,
            notifyWhatsApp: true
          }
        };
        const passengers = [];
        for (let paxInd = 0; paxInd < passengerInfo.length; paxInd++) {
          const paxInfo = passengerInfo[paxInd];
          passengers.push({
            passengerKey: paxInfo?.key,
            mobileNumber: paxInfo?.mobile,
            age: paxInfo?.age,
            email: paxInfo?.emailId,
            pinCode: paxInfo?.destinationPin,
            destinationAddress: paxInfo?.destinationAddress
          });
        }
        apiObj.passengers = passengers;
        // make the api call :
        const responseAPI = await checkinForSegments(apiObj);

        if (responseAPI?.data?.data?.checkedIn) {
          response.data.push(responseAPI.data.data.checkedIn);
        } else {
          response.status = false;
        }
      }
    }
    return response;
  } catch (error) {
    console.warn(error);
    return errorHandingErrorMessage(ERROR_API_NAME.CHECKIN, error);
  }
}

export function checkStatusOfCheckin(response, resourceData) {
  try {
    let resObj = {
      status: true,
      code: 200,
      data: "",
      message: ""
    };
    if (response?.data?.checkinByJourneyRequirements?.restrictions) {
      if (response?.data?.checkinByJourneyRequirements?.restrictions.includes("NotOpened")) {
        resObj = {
          status: false,
          code: 200,
          data: "",
          message: extractResource(resourceData, "onlineCheckInOpens48Hours")
        };
        return resObj;
      }
      if (response?.data?.checkinByJourneyRequirements?.restrictions.includes("Closed")) {
        resObj = {
          status: false,
          code: 200,
          data: "",
          message: extractResource(resourceData, "checkInClosed")
        };
        return resObj;
      }
    }
    return resObj;
  } catch (error) {
    const resObj = {
      status: false,
      code: 500,
      data: error,
      message: "Something went wrong."
    };
    return resObj;
  }
}

const restrictionSsrArray = ["WCHC", "AKYP", "BLND", "INFT", "MEDA", "OXYG", "STCR", "WCHC", "WCHR", "WCHS", "UMNR"];

function restrictionsSSr(ssrsArr) {
  return restrictionSsrArray.includes(ssrsArr.ssrCode);
}

export function checkForSSRRestriction(bookingInfo) {
  let response = {};
  response.isOverAll = false;
  try {
    const { journeys } = bookingInfo;
    for (let index = 0; index < journeys.length; index++) {
      const segs = journeys[index]?.segments;
      for (let indseg = 0; indseg < segs.length; indseg++) {
        const pagSeg = segs[indseg]?.passengerSegment;
        for (let pegSegInd = 0; pegSegInd < pagSeg.length; pegSegInd++) {
          const paxSsr = pagSeg[pegSegInd]?.ssrs;
          response[pagSeg[pegSegInd]?.passengerKey] = paxSsr.filter(restrictionsSSr).length != 0;
          if (!response.isOverAll && response[pagSeg[pegSegInd]?.passengerKey]) {
            response.isOverAll = true;
          }
        }
      }
    }
    if (bookingInfo?.extraSeatPassengers?.length > 0) {
      response.isOverAll = true;      
    }
  } catch (error) {
    response = false;
    console.warn(error);
  }
  return response;
}

export async function checkForPaxSeatInfo(bookingInfo: any, userInfo = null) {
  let response: any = {};
  let length = 0;

  const users: any[] = [];
  if (userInfo && Array.isArray(userInfo)) {
    userInfo.map(({ info }: any) => users.push(info.passengerKey));
  }

  try {
    if (bookingInfo) {
      const { journeys } = bookingInfo;

      for (let journeyIndex = 0; journeyIndex < journeys.length; journeyIndex += 1) {
        const segments = journeys[journeyIndex]?.segments;

        for (let segmentIndex = 0; segmentIndex < segments.length; segmentIndex += 1) {
          const segment = segments[segmentIndex];
          const passengerSegment = deepCopy(segment?.passengerSegment);
          response[segment?.segmentKey] = {};

          for (let paxSegmentIndex = 0; paxSegmentIndex < passengerSegment.length; paxSegmentIndex += 1) {
            const paxSeat = deepCopy(passengerSegment[paxSegmentIndex]?.seats);

            if (paxSeat.length) {
              length += 1;

              if ((users && users.includes(passengerSegment[paxSegmentIndex]?.passengerKey)) || users.length > 0) {
                response[segments[segmentIndex]?.segmentKey][passengerSegment[paxSegmentIndex].passengerKey] =
                  deepCopy(paxSeat);
                response[segments[segmentIndex]?.segmentKey][
                  passengerSegment[paxSegmentIndex].passengerKey
                ].name = `${bookingInfo?.passengers[paxSegmentIndex]?.name?.first} ${bookingInfo?.passengers[paxSegmentIndex]?.name?.last}`;
              } else {
                response[segments[segmentIndex]?.segmentKey][passengerSegment[paxSegmentIndex].passengerKey] =
                  deepCopy(paxSeat);
                response[segments[segmentIndex]?.segmentKey][
                  passengerSegment[paxSegmentIndex].passengerKey
                ].name = `${bookingInfo?.passengers[paxSegmentIndex]?.name?.first} ${bookingInfo?.passengers[paxSegmentIndex]?.name?.last}`;
              }
              response[segments[segmentIndex]?.segmentKey][passengerSegment[paxSegmentIndex].passengerKey].seatmapReference = segment?.legs?.[0]?.seatmapReference
            }
          }
        }
      }
      response.length = length;
    }
    return response;
  } catch (error) {
    console.error("Error in check for Pax seat info function", error);
    return null;
  }
}

export function checkForPaxSeatInfoAtJourneyLevel(bookingInfo, journeyKey = null) {
  let response = {};
  // response['isOverAll'] = false;
  const users = [];

  try {
    const { journeys } = bookingInfo;
    for (let index = 0; index < journeys.length; index++) {
      const segs = journeys[index]?.segments;
      for (let indseg = 0; indseg < segs.length; indseg++) {
        const pagSeg = segs[indseg]?.passengerSegment;
        response[segs[indseg]?.segmentKey] = {};
        for (let pegSegInd = 0; pegSegInd < pagSeg.length; pegSegInd++) {
          const paxSeat = deepCopy(pagSeg[pegSegInd]?.seats);
          if (paxSeat.length === 1) {
            if (users.includes(pagSeg[pegSegInd]?.passengerKey) || users.length > 0) {
              response[segs[indseg]?.segmentKey][pagSeg[pegSegInd]?.passengerKey] = deepCopy(paxSeat);
              response[segs[indseg]?.segmentKey][
                pagSeg[pegSegInd]?.passengerKey
              ].name = `${bookingInfo?.passengers[pegSegInd]?.name?.first} ${bookingInfo?.passengers[pegSegInd]?.name?.last}`;
            } else {
              response[segs[indseg]?.segmentKey][pagSeg[pegSegInd]?.passengerKey] = deepCopy(paxSeat);
              response[segs[indseg]?.segmentKey][
                pagSeg[pegSegInd]?.passengerKey
              ].name = `${bookingInfo?.passengers[pegSegInd]?.name?.first} ${bookingInfo?.passengers[pegSegInd]?.name?.last}`;
            }
          } else {
            return response;
          }
        }
      }
    }
  } catch (error) {
    response = false;
    console.warn(error);
  }
  return response;
}

export function checkedInUsersByJourneyKey(bookingInfo, journeyKey) {
  let response: any = [];

  try {
    const { passengerSegments } = bookingInfo;
    for (let index = 0; index < passengerSegments.length; index++) {
      if (passengerSegments[index]?.journeyKey == journeyKey) {
        const segment = passengerSegments[index]?.segments;
        for (let i = 0; i < segment.length; i++) {
          const passenger = segment[i].passengerSegment;
          for (let j = 0; j < passenger.length; j++) {
            if (passenger[j].value.liftStatus == "CheckedIn") {
              const passengerData = bookingInfo.passengers.filter((data) => data.key == passenger[j].passengerKey);
              const user = {
                name: `${passengerData[0]?.value?.name.first} ${passengerData[0]?.value?.name.last}`,
                key: passenger[j].passengerKey,
                isInfant: false,
                segmentKey: segment[i].segmentKey
              };
              response.push(user);
              if (passengerData[0].value.infant != null) {
                const infant = {
                  name: `${passengerData[0]?.value?.infant.name.first} ${passengerData[0]?.value?.infant.name.last}`,
                  key: passenger[j].passengerKey,
                  isInfant: true,
                  segmentKey: segment[i].segmentKey
                };
                response.push(infant);
              }
            }
          }
        }
      }
    }
  } catch (error) {
    response = false;
    console.warn(error);
  }

  return response;
}

export function paxCountForSeatAllocated(paxJourneySeats, segment, pax = null) {
  try {
    let paxCount = 0;

    if (Object.keys(paxJourneySeats).length == 0) {
      return paxCount;
    }
    if (segment && segment.length) {
      for (let segmentIndex = 0; segmentIndex < segment.length; segmentIndex++) {
        const segmentInfo = segment[segmentIndex];
        paxCount += Object.keys(paxJourneySeats[segmentInfo?.key]).length;
      }
    }
    return paxCount;
  } catch (error) {
    console.warn(error);
    return 0;
  }
}
export function checkForPreBookSeats(paxJourneySeats, segment, pax = null) {
  try {
    const response = true;
    if (Object.keys(paxJourneySeats).length == 0) {
      return false;
    }
    if (segment && segment.length) {
      const segmentKey = segment[0]?.key;
      if (Object.keys(paxJourneySeats[segmentKey]).length == 0) {
        return false;
      }
    }
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
}
export function preSeatInfo(bookingInfo, segment = null, userInfo = null) {
  let response = {};
  // response['isOverAll'] = false;
  const users = [];
  if (userInfo) {
    userInfo.map((info, key) => {
      users.push(info.passengerKey);
    });
  }
  if (segment == null) {
    segment = bookingInfo?.passengerSegments[0]?.journeyKey;
  }
  try {
    const { journeys } = bookingInfo;
    if (journeys) {
      for (let index = 0; index < journeys.length; index++) {
        const segs = journeys[index]?.segments;
        if (journeys[index].journeyKey == segment) {
          for (let indseg = 0; indseg < segs.length; indseg++) {
            const pagSeg = segs[indseg]?.passengerSegment;
            for (let pegSegInd = 0; pegSegInd < pagSeg.length; pegSegInd++) {
              const paxSeat = deepCopy(pagSeg[pegSegInd]?.seats);
              for (const seat of paxSeat) {
                if (users.includes(pagSeg[pegSegInd]?.passengerKey) || users.length > 0) {
                  response[seat?.unitKey] = deepCopy(seat);
                  response[
                    seat?.unitKey
                  ].name = `${bookingInfo?.passengers[pegSegInd]?.name?.first} ${bookingInfo?.passengers[pegSegInd]?.name?.last}`;
                  response[seat?.unitKey].passengerKey = pagSeg[pegSegInd]?.passengerKey;
                } else {
                  response[seat?.unitKey] = deepCopy(seat);
                  response[
                    seat?.unitKey
                  ].name = `${bookingInfo?.passengers[pegSegInd]?.name?.first} ${bookingInfo?.passengers[pegSegInd]?.name?.last}`;
                  response[seat?.unitKey].passengerKey = pagSeg[pegSegInd]?.passengerKey;
                }
              }
            }
          }
        }
      }
    }
  } catch (error) {
    response = false;
    console.warn(error);
  }
  return response;
}

export async function getDecryptedCheckinData(requestObject: object) {
  const responseAPI = await decryptCheckinData(requestObject);
  return responseAPI;
}

export const getOrginAndDestinationCities = async () => {
  const orginAndDestinationCities = await OriginAndDestination();
  return orginAndDestinationCities?.data?.stations?.values || [];
};
